@if(contact) {
<div class="px-6 py-5 max-w-6xl mx-auto">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

    <!-- Contact info -->
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-6 space-y-6 order-last md:order-first">
      <h2 class="text-lg font-bold text-mustard-700 dark:text-mustard-400">Información de contacto</h2>

      <div class="space-y-5">
        <div class="flex items-start gap-4">
          <div class="w-10 h-10 rounded-lg bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center flex-shrink-0">
            <i class="pi pi-map-marker text-vivid-royal-500 dark:text-vivid-royal-300"></i>
          </div>
          <div>
            <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Dirección</h3>
            <p class="text-sm text-vivid-royal-400 dark:text-dark-khaki-200 mt-0.5">{{ contact.address }}</p>
          </div>
        </div>

        <div class="flex items-start gap-4">
          <div class="w-10 h-10 rounded-lg bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center flex-shrink-0">
            <i class="pi pi-phone text-vivid-royal-500 dark:text-vivid-royal-300"></i>
          </div>
          <div>
            <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Teléfono</h3>
            <p class="text-sm text-vivid-royal-400 dark:text-dark-khaki-200 mt-0.5">{{ contact.phone }}</p>
          </div>
        </div>

        <div class="flex items-start gap-4">
          <div class="w-10 h-10 rounded-lg bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center flex-shrink-0">
            <i class="pi pi-envelope text-vivid-royal-500 dark:text-vivid-royal-300"></i>
          </div>
          <div>
            <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Correo electrónico</h3>
            <p class="text-sm text-vivid-royal-400 dark:text-dark-khaki-200 mt-0.5">{{ contact.email }}</p>
          </div>
        </div>

        <div class="flex items-start gap-4">
          <div class="w-10 h-10 rounded-lg bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center flex-shrink-0">
            <i class="pi pi-clock text-vivid-royal-500 dark:text-vivid-royal-300"></i>
          </div>
          <div>
            <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Horarios de atención</h3>
            <p class="text-sm text-vivid-royal-400 dark:text-dark-khaki-200 mt-0.5">{{ contact.hours }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Form iframe -->
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-6 order-first md:order-last">
      <h2 class="text-lg font-bold text-mustard-700 dark:text-mustard-400 mb-2">¿Necesitas ayuda?</h2>
      <p class="text-sm text-vivid-royal-400 dark:text-dark-khaki-200 mb-4">Llena el siguiente formulario y a la brevedad atenderemos tu caso.</p>
      <iframe aria-label="Contacto Clientes" class="w-full h-[700px] rounded-lg" name="zsfeedbackFrame"
        scrolling="false" allowtransparency="false" frameborder="0" style="border:none;"
        [src]="formUrl">
      </iframe>
    </div>
  </div>
</div>
}
